module.exports = __webpack_public_path__ + "img/job-opportunities.25770184.svg";